<div class="app-pie-chart unselectable container-fluid">
<div class="row pie-chart-row">
  <div class="col-md">
  <div class="table-container">
      <app-data-table
      *ngIf="config.data.length && tableConfig"
      [config]="tableConfig"
      (getData)="pieChartTableService.chartTableGetData($event, config.data)"
    >
    </app-data-table>
  </div> 
  </div>
  <div class="col-md">
    <div class="canvas-container">
      <canvas
        baseChart
        [data]="config.data | getProps: 'value'"
        [options]="config.options"
        [plugins]="config.plugins"
        [labels]="config.data | getProps: 'label'"
        [chartType]="config.chartType"
        [legend]="config.legend"
        [colors]="config.colors"
      >
      </canvas>
    </div>
  </div>
</div>
</div>
